import ProjectList from '@app/modules/projects/projects/project-list/ProjectList';
import { FC, useState } from 'react';
import Button from '@app/shared/components/button/Button';
import PlusSvg from '@app/shared/icons/legacy/PlusSvg';
import { ButtonAppearance } from '@app/shared/components/button/button-enums';
import NewProjectFormModal from '@app/modules/projects/inputs/project-admin-new/project-form/NewProjectFormModal';
import ImportProjectModal from '@app/modules/projects/projects/import-project/ImportProjectModal';
import EntryPageRoutesWrapper from '@app/shared/components/entry-page-routes-wrapper/EntryPageRoutesWrapper';
import { featureAvailability } from '@core/utils/feature-availability';
import { useAppSelector } from '@core/hooks/redux-hooks';
import { useLocale } from '@app/core/hooks/useLocale';
import { FeatureFlags, getFeatureFlag } from '@app/core/feature-flags/feature-flags';

const Projects: FC = (): JSX.Element => {
  const { l } = useLocale();
  const [isCreateProjectModalOpen, setIsCreateProjectModalOpen] = useState(false);
  const [isImportProjectModalOpen, setIsImportProjectModalOpen] = useState(false);
  const { userInfo } = useAppSelector((state) => state.userInfo);
  const isDevToolsEnabled = getFeatureFlag(FeatureFlags.EraDevTools);

  return (
    <EntryPageRoutesWrapper
      actions={
        <>
          {featureAvailability(['TeamMember'], userInfo) && (
            <Button
              autoIconSize
              startIcon={<PlusSvg />}
              appearance={ButtonAppearance.DEFAULT_PRIMARY}
              onClick={() => setIsCreateProjectModalOpen(true)}>
              {l('_NewProject')}
              <NewProjectFormModal
                setIsOpen={setIsCreateProjectModalOpen}
                isOpen={isCreateProjectModalOpen}
              />
            </Button>
          )}
          {isDevToolsEnabled && (
            <Button
              appearance={ButtonAppearance.DEFAULT_SECONDARY}
              onClick={() => setIsImportProjectModalOpen(true)}>
              {l('_ImportProject')}
              <ImportProjectModal
                setIsOpen={setIsImportProjectModalOpen}
                isOpen={isImportProjectModalOpen}
              />
            </Button>
          )}
        </>
      }>
      <ProjectList />
    </EntryPageRoutesWrapper>
  );
};

export default Projects;
